const Footer = () => {
    return (
        <footer className='footer py-4'>
            <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-lg-4 text-lg-start'>
                        <span>Sede amministrativa e operativa: Via Civitacampomarano, 8, 00131, Roma</span>
                        <span className='d-block'>C.F. e P.IVA 02047670662</span>
                        <span className='d-block'>SDI: BA6ET11</span>
                        <span className='d-block'>Albo autotrasportatori n. AQ6512331Q</span>
                        <span className='d-block'>Aut. Trasporto rifiuti cat. 4F 5F n. 08172 del 28.09.2022</span>
                    </div>
                    <div className='col-lg-8 text-lg-end mt-2'>
                        <a
                            href='https://www.iubenda.com/privacy-policy/30787734'
                            className='iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe '
                            title='Privacy Policy '
                        >
                            Privacy Policy
                        </a>
                        <a
                            href='https://www.iubenda.com/privacy-policy/30787734/cookie-policy'
                            className='iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe '
                            title='Cookie Policy '
                        >
                            Cookie Policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
